import { useEffect, useRef, useState } from "react";
import emailjs from "@emailjs/browser";
import { links, person } from "../data/site";
import { Reveal } from "./motion";

const MAX_MESSAGES_PER_DAY = 3;
const STORAGE_KEY = "messagesData";

export default function Contact() {
  const form = useRef(null);
  const [sent, setSent] = useState(false);
  const [sending, setSending] = useState(false);
  const [error, setError] = useState("");
  const [messagesData, setMessagesData] = useState([]);

  useEffect(() => {
    const stored = localStorage.getItem(STORAGE_KEY);
    if (stored) {
      try {
        setMessagesData(JSON.parse(stored));
      } catch {
        localStorage.removeItem(STORAGE_KEY);
      }
    }
  }, []);

  const sendEmail = (event) => {
    event.preventDefault();
    setError("");

    const today = new Date().toISOString().split("T")[0];
    const sentToday = messagesData.filter((message) => message.date === today);

    if (sentToday.length >= MAX_MESSAGES_PER_DAY) {
      setError("That is three messages today already. Try again tomorrow, or reach me on LinkedIn.");
      return;
    }

    setSending(true);
    emailjs
      .sendForm(
        process.env.REACT_APP_EMAILJS_SERVICE_ID,
        process.env.REACT_APP_EMAILJS_TEMPLATE_ID,
        form.current,
        process.env.REACT_APP_EMAILJS_PUBLIC_KEY
      )
      .then(
        () => {
          setSending(false);
          setSent(true);
          form.current.reset();

          const updated = [
            ...messagesData,
            { date: today, time: new Date().toLocaleTimeString() },
          ];
          setMessagesData(updated);
          localStorage.setItem(STORAGE_KEY, JSON.stringify(updated));
        },
        () => {
          setSending(false);
          setError("That did not send. Reach me on LinkedIn or WhatsApp instead.");
        }
      );
  };

  return (
    <section className="section contact" id="contact">
      <div className="shell contact__grid">
        <Reveal className="contact__aside">
          <p className="label">Contact</p>
          <h2 className="display contact__headline">
            Have something
            <br />
            worth building?
          </h2>
          <p className="soft measure">
            {person.short} is in {person.location}, working in GMT+7. A short
            message with what you need is enough to start.
          </p>

          <ul className="contact__direct">
            <li>
              <a className="link" href={links.linkedin} target="_blank" rel="noreferrer">
                LinkedIn
              </a>
            </li>
            <li>
              <a className="link" href={links.whatsapp} target="_blank" rel="noreferrer">
                WhatsApp
              </a>
            </li>
            <li>
              <a className="link" href={links.github} target="_blank" rel="noreferrer">
                GitHub
              </a>
            </li>
          </ul>
        </Reveal>

        <form className="contact__form" ref={form} onSubmit={sendEmail}>
          <div className="field">
            <label className="label" htmlFor="name">
              Name
            </label>
            <input id="name" type="text" name="user_name" required autoComplete="name" />
          </div>

          <div className="field">
            <label className="label" htmlFor="email">
              Email
            </label>
            <input id="email" type="email" name="user_email" required autoComplete="email" />
          </div>

          <div className="field">
            <label className="label" htmlFor="message">
              Message
            </label>
            <textarea id="message" name="message" rows={5} required />
          </div>

          <button type="submit" className="cta cta--solid" disabled={sending}>
            {sending ? "Sending" : "Send message"}
          </button>

          <p className="contact__status" role="status" aria-live="polite">
            {sent && !error && "Thanks. It arrived, I will reply from my inbox."}
            {error}
          </p>
        </form>
      </div>
    </section>
  );
}
